<template>
  <div class="accordion-items">
    <div class="d-flex justify-content-between">
      <b-button v-b-toggle="'accordion-'+group.id" :variant="'empty'" class="font-weight-normal accordion-expand accordion-toggle">
        <strong>{{ group.name }} ({{ group.children.length }})</strong>
        <font-awesome-icon class="mx-2" size="xs" :icon="'chevron-right'" />
      </b-button>
      <b-button variant="link" @click="$emit('removeGroup', group.id)">
        {{ $t('Remove All') }}
      </b-button>
    </div>
    <b-collapse :id="'accordion-'+group.id" :ref="'pca-'+group.id" :accordion="'my-accordion-pc'" role="tabpanel">
      <ul class="list-unstyled ml-1 p-1 row">
        <li
          v-for="(pc, pcid) in group.children"
          :key="pcid"
          class="my-1 col-12 col-sm-6 col-md-3 col-lg-6 col-xxl-4"
          @click.prevent.stop="$emit('remove',pc)"
        >
          <span class="text-nowrap">
            <b-checkbox :checked="true" class="forced-pointer">
              {{ pc.name }}
            </b-checkbox>
          </span>
        </li>
      </ul>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "PostcodeAccordion",
  props: ['group'],
  data: function() {
    return {
      internal: null,
    }
  },
  methods: {
    hasChanged: function(value) {
      return JSON.stringify(value) !== JSON.stringify(this.internal)
    }
  },
  watch: {
    group: function(value) {
      if (this.hasChanged(value)) {
        this.$refs['pca-'+this.group.id].show = true;
        this.internal = value;
      }
    }
  },
  mounted: function() {
    this.$refs['pca-'+this.group.id].show = true;
    this.internal = this.group;
  }
}
</script>

<style scoped lang="scss">
  .forced-pointer {
    ::v-deep .custom-control-label {
      cursor:pointer !important;
    }
  }
</style>
